const getSafeOrigin = () => {
  if (typeof window === 'undefined' || !window.location) {
    return '';
  }

  try {
    return new URL(window.location.href).origin.replace(/\/+$/, '');
  } catch {
    return String(window.location.origin || '').replace(/\/+$/, '');
  }
};

const normalizeInvitePath = (path = '') => {
  const raw = String(path || '').trim();
  if (!raw) return '/';

  try {
    const origin = getSafeOrigin();
    if (origin && raw.startsWith(origin)) {
      const parsed = new URL(raw);
      return `${parsed.pathname}${parsed.search}${parsed.hash}`.replace(/\/{2,}/g, '/');
    }
  } catch {
    // Fall back to string cleanup.
  }

  return `/${raw.replace(/^\/+/, '')}`.replace(/\/{2,}/g, '/');
};

export const buildInviteLink = (path = '') => {
  const origin = getSafeOrigin();
  const cleanPath = normalizeInvitePath(path);
  return origin ? `${origin}${cleanPath}` : cleanPath;
};

